import React from 'react';
import { Paper, Grid, Typography, CardActions } from 'material-ui';
import { withStyles } from 'material-ui/styles/index'; // only needs to be imported once
import { translate } from 'react-i18next';
import DropDownMenu from '../../ui/DropDownMenu';
import DynIcon from '../Utils/DynIcon';
import currencyFormatter from 'currency-formatter';
import SelectNative from '../../ui/SelectNative';

const styles = theme => ({
    clientRowTitle: {
        fontSize: '14px',
        fontWeight: 600,
        paddingLeft: '20px !important',
    },
    destinationTable: {
        width: '100%',
        verticalAlign: 'top',
    },
    destinationTableViewOnlyMode: {
        verticalAlign: 'top',
    },
    destinationTableCol1: {
        verticalAlign: 'middle',
        width: '82px'
    },
    destinationTableCol3: {
        verticalAlign: 'middle',
        width: '100px'
    },
    destinationTableCol4: {
        verticalAlign: 'top',
        width: '240px',
        maxWidth: '240px'
    },
    destinationTableColViewOnlyMode: {
        verticalAlign: 'middle',
        width: '250px',
        height: '34px',
    },
    clientRowValue: {
        fontSize: '14px',
        fontWeight: 300,
    },
    expandIcon: {
        color: theme.palette.primary.main
    },
    bookingTitle: {
        color: theme.palette.primary.main,
        padding: '20px 0 20px 25px',
        fontWeight: 'bold',
        fontSize: '1.2rem',
        borderLeft: '2px solid ' + theme.palette.primary.main
    },
    bookingName: {
        marginLeft: '260px',
        marginBottom: '20px',
        fontWeight: 'bold',
        fontSize: '1.2rem'
    },
    paperFrame: {
        margin: '40px 20px 0px 0px',
        width: '100%'
    },
    fliped: {
        '-moz-transform': 'scaleX(-1)',
        '-o-transform': 'scaleX(-1)',
        '-webkit-transform': 'scaleX(-1)',
        'transform': 'scaleX(-1)',
        'filter': 'FlipH',
        '-ms-filter': 'FlipH',
    },
    circle: {
        width: '71px',
        backgroundColor: theme.palette.primary.main,
        borderRadius: '75px',
        height: '71px',
        textAlign: 'center',
        display: 'table-cell',
        color: 'white',
        verticalAlign: 'middle'
    },
    blue: {
        color: theme.palette.primary.main
    },
    price: {
        marginTop: '0px',
        marginBottom: '4px',
        fontWeight: 700,
        fontSize: '1.5em',
        color: 'var(--error-color)',
        textAlign: 'right'
    },
});


class TransferDetailRender extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pickup: null,
            originMtpFromError: true,
            destinationMtpFromError: true,
            originMtpToError: true,
            destinationMtpToError: true
        };
    }

    handlePickChange = (value) => {
        alert(value);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.originMtpFromError !== this.state.originMtpFromError) {
            this.setState({ originMtpFromError: nextProps.originMtpFromError });
        }
        if (nextProps.destinationMtpFromError !== this.state.destinationMtpFromError) {
            this.setState({ destinationMtpFromError: nextProps.destinationMtpFromError });
        }
        if (nextProps.originMtpToError !== this.state.originMtpToError) {
            this.setState({ originMtpToError: nextProps.originMtpToError });
        }
        if (nextProps.destinationMtpToError !== this.state.destinationMtpToError) {
            this.setState({ destinationMtpToError: nextProps.destinationMtpToError });
        }
    }

    getKidsCount(kids) {
        if (Array.isArray(kids)) {
            return kids.length;
        }

        return kids;
    }

    renderOccupation = () => {
        const { t, transfer } = this.props;
        const kids = this.getKidsCount(transfer.kids);
        return (
            <Typography>
                <DynIcon icon="Group" style={{ color: 'var(--primary-color)' }} />&nbsp;
                {t('COMMON.ADULT', { count: transfer.adults })} {kids > 0 ? ', ' + t('COMMON.KID', { count: kids }) : ''}
            </Typography>
        );
    }

    renderTrip = (data, type) => {

        const { viewOnlyMode, classes, t, transfer, setMeetingPoint /* currentUser */ } = this.props;
        return (
            <Grid container alignItems="flex-start" style={{ marginBottom: 20 }}>
                <Grid item style={{ width: '100%' }}>
                    <img src={transfer.image} alt="cab logo" style={{ objectFit:'cover', width: '100%', height: '350px' }} />
                </Grid>
                <Grid item xs className="cmsTransfersColumn">
                        <div>
                            <span>
                                {t(`TRANSFERS.${type.toUpperCase()}`)}
                            </span>
                            <span>
                                {data.name}
                            </span>
                        </div>                                
                        <div>
                            <span>
                                <Typography>{t('BOOKINGS.DATE')}:</Typography>
                                <Typography><DynIcon icon="Event" style={{ color: 'var(--primary-color)' }} /> {data.dateTime.split(' ')[0]}&nbsp;</Typography>
                            </span>
                            <span>
                                <Typography>{t('INVOICES.PASSENGERS')}:</Typography>
                                {this.renderOccupation()}
                            </span>
                        </div>                    
                        <div className={classes.destinationTableViewOnlyMode}>                       
                            <span>
                                <Typography>
                                    <DynIcon icon="LocationOn" style={{ color: 'var(--primary-color)' }} />
                                    {t('COMMON.FROM')}:
                                </Typography>
                                <Typography>{data.originZone.name}</Typography>
                            </span>
                            <span className={classes.destinationTableCol3}>
                                <Typography className={classes.blue}>
                                    <DynIcon icon="PinDrop" style={{ color: 'var(--primary-color)' }} />
                                    {t('TRANSFERS.PICKUP')}:
                                </Typography>
                           {
                                    !viewOnlyMode ?
                                        <SelectNative id={type + 'Origin'}
                                            selection={data.originMeetingPoint.code ? data.originMeetingPoint.code.toString() : null}
                                            error={type === 'From' ? this.state.originMtpFromError : this.state.originMtpToError}
                                            onChange={(val) => {
                                                if (setMeetingPoint) {
                                                    const method = type + 'Origin';
                                                    setMeetingPoint({ code: val, name: '' }, method);
                                                    if (type === 'From') {
                                                        //this.setState({ originMtpFromError: val !== null });
                                                    }
                                                    else {
                                                        //this.setState({ originMtpToError: val !== null });
                                                    }
                                                }
                                            }}
                                            options={data.originMeetingPoint.options} />
                                        :
                                        <Typography>{data.originMeetingPoint.name}</Typography>
                                }
                            </span>
                            <span className={classes.destinationTableCol1}>
                                <Typography className={classes.blue}>
                                    <DynIcon icon="LocationOn" style={{ color: 'var(--primary-color)' }} />
                                    {t('COMMON.TO')}:
                                </Typography>
                                <Typography>
                                    {data.destinationZone.name}
                                </Typography>
                            </span>
                            <span className={classes.destinationTableCol3}>
                                <Typography className={classes.blue}>
                                    <DynIcon icon="PinDrop" style={{ color: 'var(--primary-color)' }} />
                                    {t('TRANSFERS.DROP')}:
                                </Typography>
                                {
                                    !viewOnlyMode ?
                                        <SelectNative id={type + 'From'}
                                            selection={data.destinationMeetingPoint.code.toString()}
                                            error={type === 'From' ? this.state.destinationMtpFromError : this.state.destinationMtpToError}
                                            onChange={(val, event) => {
                                                if (setMeetingPoint) {
                                                    const method = type + 'Destination';
                                                    setMeetingPoint({ code: val, name: '' }, method);
                                                    if (type === 'From') {
                                                        //this.setState({ destinationMtpFromError: val !== null });
                                                    }
                                                    else {
                                                        //this.setState({ destinationMtpToError: val !== null });
                                                    }
                                                }
                                            }}
                                            options={data.destinationMeetingPoint.options}
                                        />
                                        :
                                        <Typography>{data.destinationMeetingPoint.name}</Typography>
                                }
                            </span>
                        </div>
                    
                </Grid>
            </Grid>
        );
    }

    isResponseFromValuation(transfer) {
        return transfer.valuationResult;
    }

    render() {
        const { classes, t, transfer, displayPrice } = this.props;
        if (!transfer) {
            return '';
        }

        let fromDetails;
        let toDetails;
        if (this.isResponseFromValuation(transfer)) {
            fromDetails = transfer.valuationResult.fromDetails;
            if (transfer.valuationResult.toDetails) {
                toDetails = transfer.valuationResult.toDetails;
            }
        }
        else {
            fromDetails = transfer.fromDetails;
            if (transfer.toDetails) {
                toDetails = transfer.toDetails;
            }
        }
        return (
            <Paper className={classes.paperFrame}>
                <Typography className={classes.bookingTitle}>
                    {t('CONFIRM_BOOKING.BOOKING_DETAILS')}
                </Typography>
                <div style={{ marginLeft: 20, marginRight: 20 }}>
                    {/** FIRST TRIP **/}
                    {this.renderTrip(fromDetails, 'From')}
                    {/** SECOND ROUNDTRIP INFO :/ **/}
                    {toDetails ? this.renderTrip(toDetails, 'To') : ''}
                </div>
                {displayPrice ?
                    <CardActions>
                        <div style={{ marginLeft: 'auto', width: '120px' }} >
                            <Typography style={{ textAlign: 'right', fontWeight: 700, fontSize: '16px', marginRight: '3rem' }}>
                                {t('BOOKING_DETAIL.PRICE')}
                            </Typography>
                            <Typography className={classes.price} style={{ textAlign: 'right', fontWeight: 700, marginBottom: '2rem', marginRight: '1rem' }}>
                                {this.props.reservation
                                    ? currencyFormatter.format(this.props.reservation.price, { code: 'EUR' })
                                    : '0€'}
                            </Typography>
                        </div>
                    </CardActions>
                    : ''
                }
            </Paper >
        );
    }
}
export default translate('translations')(withStyles(styles)(TransferDetailRender));



// WEBPACK FOOTER //
// ./src/components/Transfers/TransferDetailRender.js